import {
  SUBSCRIPTION_ACTIVATE_REQUEST,
  SUBSCRIPTION_ACTIVATE_SUCCESS,
  SUBSCRIPTION_ACTIVATE_FAIL,
  SUBSCRIPTION_ACTIVATE_RESET,
  SUBSCRIPTION_PAY_REQUEST,
  SUBSCRIPTION_PAY_SUCCESS,
  SUBSCRIPTION_PAY_FAIL,
  SUBSCRIPTION_PAY_RESET,
  SUBSCRIPTION_DETAILS_REQUEST,
  SUBSCRIPTION_DETAILS_SUCCESS,
  SUBSCRIPTION_DETAILS_FAIL,
  SUBSCRIPTION_DETAILS_RESET,
} from "../Constants/SubscriptionConstants";

// ACTIVATE SUBSCRIPTION
export const subscriptionActivateReducer = (state = {}, action) => {
  switch (action.type) {
    case SUBSCRIPTION_ACTIVATE_REQUEST:
      return { loading: true };
    case SUBSCRIPTION_ACTIVATE_SUCCESS:
      return { loading: false, success: true, result: action.payload };
    case SUBSCRIPTION_ACTIVATE_FAIL:
      return { loading: false, error: action.payload };
    case SUBSCRIPTION_ACTIVATE_RESET:
      return {};
    default:
      return state;
  }
};

// PAY SUBSCRIPTION
export const subscriptionPayReducer = (state = {}, action) => {
  switch (action.type) {
    case SUBSCRIPTION_PAY_REQUEST:
      return { loading: true };
    case SUBSCRIPTION_PAY_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case SUBSCRIPTION_PAY_FAIL:
      return { loading: false, error: action.payload };
    case SUBSCRIPTION_PAY_RESET:
      return {};
    default:
      return state;
  }
};

// GET SUBSCRIPTION Details
export const subscriptionDetailsReducer = (state = {}, action) => {
  switch (action.type) {
    case SUBSCRIPTION_DETAILS_REQUEST:
      return { loading: true };
    case SUBSCRIPTION_DETAILS_SUCCESS:
      return { loading: false, success: true, item: action.payload };
    case SUBSCRIPTION_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case SUBSCRIPTION_DETAILS_RESET:
      return {};
    default:
      return state;
  }
};
